import {
    CurrencyISOCode,
    BreakdownPriceTier,
    FormattedBreakdownPriceTier
} from "@/components/wpl/pricing/src/price-finder/constants.tsx";
import { CCPOfferingContent } from "@/contentful/product-catalog.tsx";

export type { BreakdownPriceTier, FormattedBreakdownPriceTier };

export type Sku = string;

export type CcpPricingData = Record<Sku, CCPOfferingContent>;

export type PlanLimitConfigs = {
    offeringSku: Sku;
    recommendationLimit: number;
    signupLimit: number;

    /**
     * @deprecated
     */
    planName: string;
};

export interface BillingCycleConfig {
    annual: boolean;
    monthly: boolean;
}

export interface Config {
    billingCycleConfig: BillingCycleConfig;
    planLimitConfigs: PlanLimitConfigs[];
    unitMinEnterprise: number;
    ccpPricingData: CcpPricingData;
    currencyISOCode: CurrencyISOCode;
    localeISOCode: string;
}

export interface InputValues {
    billingCycle: BillingCycle;
    unitCount: number;
}

export type Currency = "USD" | "JPY";

export type BillingCycle = "MONTHLY" | "ANNUAL";
